import { queryOptions } from '@tanstack/react-query';

import { backendApis } from '@/backendApis';
import { type WorldModelDocListItem } from '@/features/world-model/world-model.types';

const WORLD_MODEL_DOC_KEYS = {
  root: ['world-model'] as const,
  list: () => [...WORLD_MODEL_DOC_KEYS.root, 'list'] as const,
  detail: (id: string) => [...WORLD_MODEL_DOC_KEYS.root, 'detail', id] as const,
};

export const getWorldModelDocsQuery = queryOptions({
  queryKey: WORLD_MODEL_DOC_KEYS.list(),
  staleTime: 1000 * 60 * 60,
  gcTime: 1000 * 60 * 60 * 4,
  retry: 3,
  queryFn: () => backendApis.worldModelDoc.getAll(),
});

export const getWorldModelDocQuery = (id: string) =>
  queryOptions({
    queryKey: WORLD_MODEL_DOC_KEYS.detail(id),
    staleTime: Infinity,
    gcTime: 1000 * 60 * 60 * 24,
    retry: 3,
    queryFn: () => backendApis.worldModelDoc.getById(id),
    enabled: Boolean(id),
  });

export const getWorldModelGraphQuery = queryOptions({
  queryKey: [...WORLD_MODEL_DOC_KEYS.root, 'graph'] as const,
  staleTime: 1000 * 60 * 60,
  gcTime: 1000 * 60 * 60 * 4,
  retry: 3,
  queryFn: () => backendApis.worldModelDoc.getGraphData(),
});

export type { WorldModelDocListItem };
